import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "calculation" }

import CurrentLanguage from '@/components/CurrentLanguage.vue';
import MediaList from '@/components/media/MediaList.vue';
import {
  Co2QuizQuestion,
  QuestionType,
  titleRules,
  questionTypeItems,
  calculationTypeItems,
  calculationLabelItems,
  CalculationType,
} from '@/models/co2-quiz.model';
import RichTextField from '@/components/common/RichTextField.vue';
import { useEvents, Event } from '@/services/events.composable';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { NEW_ID } from '@/util/constants';
import { computed, onMounted, PropType, ref, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import {
  Co2QuizStoreActions,
  Co2QuizStoreState,
} from '@/stores/co2-quiz.store';
import Co2QuizAnswersField from '@/components/co2quiz/Co2QuizAnswersField.vue';
import Co2QuizPartQuestionsField from '@/components/co2quiz/Co2QuizPartQuestionsField.vue';
import CategoriesField from '@/components/categories/CategoriesField.vue';
import LinksField from '@/components/common/LinksField.vue';
import { LabelsActions, LabelsState } from '@/stores/labels.store';
import { UserLabel } from '@/models/label.model';
import Co2CalculationWarnings from '@/components/co2quiz/Co2CalculationWarnings.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Co2QuestionForm',
  props: {
  data: {
    type: Object as PropType<Co2QuizQuestion>,
  },
},
  setup(__props) {

const store = useStore<
  ShiftCMSState & { co2: Co2QuizStoreState; ls: LabelsState }
>();
const questions = computed<Co2QuizQuestion[]>(() => store.state.co2.questions);
const labels = computed<UserLabel[]>(() => store.state.ls.labels);

const events = useEvents();

const props = __props;

const valid = ref<boolean>(false);

const question = ref<Co2QuizQuestion>({
  id: NEW_ID,
  title: '',
  hint: '',
  index: questions.value.length,
  unitValue: 0,
  averageValue: 0,
  isQuickScan: false,
  isDismissable: false,
  isValue: false,
  questionType: QuestionType.Answers,
  calculationType: CalculationType.Value,
  calculationLabels: [],
  answers: [],
  categories: [],
  relatedQuestions: [],
  media: [],
  description: '',
  sources: [],
  ...(props.data || {}),
});

const action = computed<string>(() =>
  question.value.id === NEW_ID ? 'Add' : 'Save',
);

const questionOptions = [
  ...questions.value.map((q) => ({ title: q.title, value: q })),
];

const saveCo2QuizQuestion = async () => {
  let success: boolean = false;

  if (valid.value && question.value.categories.length !== 0) {
    if (question.value.id === NEW_ID) {
      success = await store.dispatch(
        Co2QuizStoreActions.AddCo2QuizQuestion,
        question.value,
      );
    } else {
      success = await store.dispatch(
        Co2QuizStoreActions.UpdateCo2QuizQuestion,
        question.value,
      );
    }
  }
  if (success) {
    events.emit(Event.Saved, true);
    store.dispatch(Actions.ShowNotification, {
      message: 'Saved question',
      type: 'success',
    });
    store.commit(Mutations.HideDrawer);
    store.dispatch(Co2QuizStoreActions.GetCo2Questions);
  }
};

const updateLanguage = async () => {
  if (question.value.id === NEW_ID) {
    Object.assign(question.value, { title: '', type: 'question' });
  } else {
    const q = await store.dispatch(
      Co2QuizStoreActions.GetCo2Question,
      question.value.id,
    );

    if (q) {
      Object.assign(question.value, { ...q });
    }
  }
};

const deleteQuestion = async () => {
  if (
    question.value &&
    confirm('Are you absolutely sure you want to delete this question?')
  ) {
    store.dispatch(Co2QuizStoreActions.DeleteQuestion, question.value.id);

    store.commit(Mutations.HideDrawer);
  }
};

onMounted(() => {
  events.on(Event.LanguageChanged, updateLanguage);
  store.dispatch(LabelsActions.GetLabels);
  if (props.data) {
    Object.assign(question.value, props.data);
  }
});

onBeforeUnmount(() => {
  events.off(Event.LanguageChanged, updateLanguage);
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: valid.value,
    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((valid).value = $event)),
    onSubmit: _withModifiers(saveCo2QuizQuestion, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, [
            _createTextVNode(_toDisplayString(_ctx.$t(action.value)) + " a question ", 1),
            _createVNode(CurrentLanguage)
          ]),
          _createVNode(_component_v_text_field, {
            modelValue: question.value.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((question.value.title) = $event)),
            rules: _unref(titleRules),
            label: "Title",
            required: ""
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(RichTextField, {
            label: "Hint",
            height: 200,
            modelValue: question.value.hint,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((question.value.hint) = $event)),
            media: question.value.media
          }, null, 8, ["modelValue", "media"]),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    label: "Quickscan Question",
                    modelValue: question.value.isQuickScan,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((question.value.isQuickScan) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    label: "Show as Co2 Value",
                    modelValue: question.value.isValue,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((question.value.isValue) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: question.value.averageValue,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((question.value.averageValue) = $event)),
                    modelModifiers: { number: true },
                    label: "Average value",
                    class: "calculation-field",
                    required: "",
                    suffix: "Kg CO₂",
                    "hide-details": "auto",
                    style: { background: 'white' },
                    hint: "This value is used as the value on the home screen"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h4", null, " Calculation " + _toDisplayString(question.value.parentQuestion ? '(question)' : '(main question)'), 1),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: question.value.questionType,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((question.value.questionType) = $event)),
                      label: "Question Type",
                      class: "calculation-field",
                      items: _unref(questionTypeItems),
                      "hide-details": "auto",
                      style: { background: 'white' },
                      required: ""
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: question.value.unitValue,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((question.value.unitValue) = $event)),
                      modelModifiers: { number: true },
                      label: "Unit value",
                      class: "calculation-field",
                      required: "",
                      suffix: "Kg CO₂",
                      "hide-details": "auto",
                      style: { background: 'white' },
                      hint: "This value is used as the basis for the Co2 calculation"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: question.value.calculationType,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((question.value.calculationType) = $event)),
                      label: "Calculation Type",
                      class: "calculation-field",
                      "hide-details": "auto",
                      style: { background: 'white' },
                      items: _unref(calculationTypeItems)
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(Co2CalculationWarnings, {
              question: question.value,
              questions: questions.value
            }, null, 8, ["question", "questions"]),
            _createVNode(_component_v_select, {
              modelValue: question.value.calculationLabels,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((question.value.calculationLabels) = $event)),
              label: "Calculation Labels",
              class: "calculation-field",
              chips: "",
              multiple: "",
              clearable: "",
              "hide-details": "auto",
              style: { background: 'white' },
              items: _unref(calculationLabelItems)
            }, {
              item: _withCtx(({ props }) => [
                _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title)
                  ]),
                  _: 2
                }, 1040)
              ]),
              _: 1
            }, 8, ["modelValue", "items"])
          ]),
          _createVNode(CategoriesField, {
            modelValue: question.value.categories,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((question.value.categories) = $event)),
            max: 1,
            required: ""
          }, null, 8, ["modelValue"]),
          (question.value.questionType !== _unref(QuestionType).PartsQuestion)
            ? (_openBlock(), _createBlock(Co2QuizAnswersField, {
                key: 0,
                modelValue: question.value.answers,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((question.value.answers) = $event)),
                questions: questions.value,
                labels: labels.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    label: "Show dismissable option",
                    modelValue: question.value.isDismissable,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((question.value.isDismissable) = $event)),
                    "hide-details": "auto",
                    density: "compact",
                    class: "ml-8"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue", "questions", "labels"]))
            : _createCommentVNode("", true),
          _cache[21] || (_cache[21] = _createElementVNode("h3", null, "Navigation", -1)),
          _createVNode(_component_v_select, {
            modelValue: question.value.chainQuestion,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((question.value.chainQuestion) = $event)),
            label: "Chain question",
            class: "mb-8",
            "hide-details": "auto",
            clearable: "",
            style: { background: 'white' },
            items: questionOptions
          }, {
            item: _withCtx(({ props }) => [
              _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title)
                ]),
                _: 2
              }, 1040)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_select, {
            modelValue: question.value.relatedQuestions,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((question.value.relatedQuestions) = $event)),
            label: "Related questions",
            multiple: "",
            clearable: "",
            class: "mt-8 mb-8",
            "hide-details": "auto",
            style: { background: 'white' },
            items: questionOptions
          }, {
            item: _withCtx(({ props }) => [
              _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title)
                ]),
                _: 2
              }, 1040)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (question.value.questionType === _unref(QuestionType).PartsQuestion)
            ? (_openBlock(), _createBlock(Co2QuizPartQuestionsField, {
                key: 1,
                modelValue: question.value,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((question).value = $event)),
                questions: questions.value
              }, null, 8, ["modelValue", "questions"]))
            : _createCommentVNode("", true),
          _cache[22] || (_cache[22] = _createElementVNode("h3", null, "Read more", -1)),
          _createVNode(RichTextField, {
            label: "Description",
            height: 200,
            modelValue: question.value.description,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((question.value.description) = $event)),
            media: question.value.media
          }, null, 8, ["modelValue", "media"]),
          _createVNode(LinksField, {
            modelValue: question.value.sources,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((question.value.sources) = $event)),
            label: "Source"
          }, null, 8, ["modelValue"]),
          _createVNode(MediaList, {
            modelValue: question.value,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((question).value = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { col: "2" }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "button",
                    color: "warning",
                    block: "",
                    onClick: deleteQuestion
                  }, {
                    default: _withCtx(() => _cache[19] || (_cache[19] = [
                      _createTextVNode("Delete")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "reset",
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[20] || (_cache[20] = [
                      _createTextVNode("Reset")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "submit",
                    color: "success",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(action.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { col: "2" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})